/* Park Friends product-card behaviour.
   Written for the rebuild. Delegated listeners on document, so it works for cards that arrive
   later from infinite pagination, carousels or a filtered re-render, with no re-binding. */
(function () {
  'use strict';

  /* --- size groups -------------------------------------------------
     Tap a group (Toddler, Youth, Mens) and the row swaps to that group's sizes, sold-out ones
     struck through. Tap the arrow to go back. Nothing navigates until a real size is chosen. */
  function closeAll(root) {
    root.querySelectorAll('[data-pf-panel]').forEach(function (p) { p.hidden = true; });
    root.querySelectorAll('[data-pf-group]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var groups = root.querySelector('.pf-card-sizes__groups');
    if (groups) groups.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var groupBtn = e.target.closest('[data-pf-group]');
    if (groupBtn) {
      e.preventDefault();
      var root = groupBtn.closest('[data-pf-sizes]');
      if (!root) return;
      var key = groupBtn.getAttribute('data-pf-group');
      var panel = root.querySelector('[data-pf-panel="' + key + '"]');
      var open = groupBtn.getAttribute('aria-expanded') === 'true';
      closeAll(root);
      if (!open && panel) {
        panel.hidden = false;
        groupBtn.setAttribute('aria-expanded', 'true');
        root.querySelector('.pf-card-sizes__groups').hidden = true;
      }
      return;
    }

    var back = e.target.closest('[data-pf-back]');
    if (back) {
      e.preventDefault();
      var r = back.closest('[data-pf-sizes]');
      if (r) closeAll(r);
    }
  });

  /* --- quick add for one-size products -----------------------------
     Only rendered on single-variant products, so there is no size or customization to skip.
     Posts to /cart/add.js and asks the theme to refresh its drawer rather than reloading. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-pf-quickadd]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('button');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }]
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r;
      })
      .then(function (response) {
        if (btn) btn.textContent = 'Added';

        /* Hand the response to the theme's own refresh so the drawer, the line items and
           the count badge all re-render, then open the drawer. refreshCartContents expects
           the raw Response, which is why the fetch chain keeps it rather than the json. */
        var done = window.refreshCartContents ? window.refreshCartContents(response) : null;

        return Promise.resolve(done).then(function () {
          var drawer = document.querySelector('#offcanvas-cart');
          if (drawer && window.bootstrap && window.bootstrap.Offcanvas) {
            window.bootstrap.Offcanvas.getOrCreateInstance(drawer).show();
            return;
          }
          /* no Bootstrap for some reason: fall back to the cart page rather than
             silently adding with no feedback */
          if (!drawer) window.location.href = '/cart';
        });
      })
      .catch(function () {
        if (btn) btn.textContent = 'Try again';
      })
      .finally(function () {
        setTimeout(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
        }, 1600);
      });
  });
})();

/* Park Friends: size-range tabs on the product page.
   Filters the existing size radios by group rather than replacing them, so all of the theme's
   variant availability and selection logic keeps working untouched.

   The theme re-renders the whole selector from the server after every size change, and that
   fresh markup opens the group of the SELECTED size. So: click Boys, pick a size, click Womens,
   and the re-render snapped the list back to Boys (David 2026-08-28). The tab the shopper chose
   is now remembered per product and re-applied after each re-render; picking a size in another
   group updates the memory, so the list never fights the shopper. */
(function () {
  'use strict';
  var chosen = {};   // product id -> group key the shopper picked

  function keyFor(list) {
    var input = list && list.querySelector('input[data-product-id]');
    return input ? input.getAttribute('data-product-id') : 'page';
  }
  function apply(tabs, list, want) {
    tabs.querySelectorAll('[data-pf-size-filter]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-pf-size-filter') === want);
    });
    list.querySelectorAll('[data-pf-size-group]').forEach(function (li) {
      li.hidden = want !== 'all' && li.getAttribute('data-pf-size-group') !== want;
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-pf-size-filter]');
    if (!tab) return;
    e.preventDefault();
    var tabs = tab.closest('[data-pf-size-tabs]');
    var wrapper = tabs && tabs.parentElement;
    var list = wrapper && wrapper.querySelector('[data-pf-size-list]');
    if (!list) return;
    var want = tab.getAttribute('data-pf-size-filter');
    chosen[keyFor(list)] = want;
    apply(tabs, list, want);
  });

  /* picking a size inside a group makes that group the remembered one */
  document.addEventListener('change', function (e) {
    var li = e.target.closest('[data-pf-size-group]');
    var list = e.target.closest('[data-pf-size-list]');
    if (!li || !list) return;
    chosen[keyFor(list)] = li.getAttribute('data-pf-size-group');
  }, true);

  /* after the theme swaps the selector markup, put the remembered tab back */
  function restore(root) {
    (root.querySelectorAll ? root.querySelectorAll('[data-pf-size-tabs]') : []).forEach(function (tabs) {
      var wrapper = tabs.parentElement;
      var list = wrapper && wrapper.querySelector('[data-pf-size-list]');
      if (!list) return;
      var want = chosen[keyFor(list)];
      if (!want) return;
      if (!tabs.querySelector('[data-pf-size-filter="' + want + '"]')) return;
      apply(tabs, list, want);
    });
  }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && (n.matches('[data-pf-size-tabs]') || n.querySelector('[data-pf-size-tabs]'))) { restore(n); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Park Friends: collapsible size section on the product page.
   Starts open so the sizes are never hidden from someone who came to buy, but can be
   folded away once chosen, which is what stops it eating the whole screen. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pf-sizebox-toggle]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-pf-sizebox]');
    if (!box) return;
    var open = box.hasAttribute('open');
    if (open) box.removeAttribute('open');
    else box.setAttribute('open', '');
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
  });
})();

/* Park Friends: production-time consent, expand the full terms. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pf-consent-toggle]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('.pf-consent');
    if (!box) return;
    var open = box.classList.toggle('is-open');
    btn.textContent = open ? 'Hide the full terms' : 'Read the full terms';
  });
})();

/* Park Friends: card size chips are links to the product. Show that something is
   happening on tap, because a jersey page is heavy and the wait reads as a dead button. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.pf-card-sizes__size, .pf-card-sizes__btn');
    if (!chip || chip.tagName !== 'A') return;
    chip.classList.add('is-loading');
    var band = chip.closest('.pf-card-band');
    if (band) band.classList.add('is-loading');
  });
  /* bfcache restore: clear it so a back-navigation does not show a stuck spinner */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.is-loading').forEach(function (el) { el.classList.remove('is-loading'); });
  });
})();

/* Park Friends: collection sort menu.
   A native <select> option list is drawn by the OS and cannot be given padding or a
   typeface, so the control is a real menu. The hidden <select> is still the source of
   truth for no-JS and assistive tech; these buttons just call the theme's own handler. */
(function () {
  'use strict';

  function close(root) {
    var menu = root.querySelector('.pf-sort__menu');
    var btn = root.querySelector('[data-pf-sort-toggle]');
    if (menu) menu.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-pf-sort-toggle]');
    if (toggle) {
      e.preventDefault();
      var root = toggle.closest('[data-pf-sort]');
      var menu = root.querySelector('.pf-sort__menu');
      var open = !menu.hidden;
      if (open) { close(root); return; }
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      return;
    }

    var opt = e.target.closest('[data-pf-sort-value]');
    if (opt) {
      e.preventDefault();
      var r = opt.closest('[data-pf-sort]');
      var value = opt.getAttribute('data-pf-sort-value');
      var select = r.querySelector('#sort-by');
      if (select) select.value = value;
      close(r);
      if (typeof window.onChangeCollectionSortBy === 'function') {
        window.onChangeCollectionSortBy(value);
      } else if (select) {
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    /* click anywhere else closes it */
    document.querySelectorAll('[data-pf-sort]').forEach(function (r) {
      if (!r.contains(e.target)) close(r);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-pf-sort]').forEach(close);
  });
})();

/* --------------------------------------------------------------------------------------
   Numbers-only inputs, for the jersey number.

   inputmode and pattern do not actually stop anything: inputmode only picks the on-screen
   keyboard, and pattern is checked at submit, by which point a customer has typed a name into
   the number box and been told off for it. This strips as they go, and covers paste, which is
   how most wrong input arrives.

   Delegated on document, because the product form re-renders when a variant changes.
   -------------------------------------------------------------------------------------- */
(function () {
	function clean(el) {
		var before = el.value;
		var after = before.replace(/\D+/g, '');
		if (after === before) return;
		/* keep the caret where the person was typing rather than throwing it to the end */
		var pos = el.selectionStart;
		var removedBefore = (before.slice(0, pos).match(/\D+/g) || []).join('').length;
		el.value = after;
		try { el.setSelectionRange(pos - removedBefore, pos - removedBefore); } catch (e) {}
	}

	['input', 'paste', 'change'].forEach(function (type) {
		document.addEventListener(type, function (event) {
			var el = event.target;
			if (!el || !el.matches || !el.matches('[data-pf-digits]')) return;
			/* paste fires before the value updates, so read it on the next tick */
			if (type === 'paste') { setTimeout(function () { clean(el); }, 0); return; }
			clean(el);
		}, true);
	});
})();
